module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/CESU-690a192fdc6795f2dd348277b82adb87.svg";